module.exports = __webpack_public_path__ + "img/call-mute-active.7fdfaf5f.svg";